import { Grid, Typography, Fab } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { Add as AddIcon } from '@material-ui/icons';


let PageHeader = ({ pageTitle, pageSubTitle, addNewUrl }: IPageHeaderProps) => {
    return (
        <Grid container alignItems="center" spacing={1} style={{ marginBottom: 16 }}>
            <Grid item xs>
                <Typography variant="h2">
                    {pageTitle}
                </Typography>
                <Typography variant="subtitle2">
                    {pageSubTitle}
                </Typography>
            </Grid>
            {addNewUrl !== undefined &&
                <Grid item>
                    <Fab
                        component={RouterLink}
                        to={addNewUrl}
                        variant="extended"
                        color="primary"
                    >
                        <AddIcon /> Add new
                    </Fab>
                </Grid>
            }
        </Grid>
    );
}

interface IPageHeaderProps {
    pageTitle: string
    pageSubTitle?: JSX.Element
    addNewUrl?: string
}

export default PageHeader;